import styles from 'css/components/presentation-status-page.module.css'
import React from 'react'
import dashiconsMegaphoneIcon from 'img/dashicons-megaphone.svg'
import dashiconsYesIcon from 'img/dashicons-yes-alt.svg'
import dashiconsPlusIcon from 'img/dashicons-plus-alt.svg'
import { Stopwatch, Timer } from './clock'
import { SECTIONS } from 'types'

interface PresentationStatusPageProps {
    icon?: React.ReactNode,
    blueText?: string,
    blackText?: string
}

const PresentationStatusPage = (props: PresentationStatusPageProps): React.JSX.Element => {
    return (
        <div className={styles.presentationStatusPage}>
            <div className={styles.iconContainer}>
                {props.icon}
                <span className={styles.blueText}>{props.blueText}</span>
            </div>
            <span className={styles.blackText}>{props.blackText}</span>
        </div>
    )
}

interface ConnectingPageProps {
    isReconnecting?: boolean
    reconnectAttempt?: number
    maxAttempts?: number
}

const ConnectingPage = ({ isReconnecting, reconnectAttempt, maxAttempts }: ConnectingPageProps = {}) => {
    let blueText = "Connecting..."
    let blackText = "Please wait while we connect."

    if (isReconnecting && reconnectAttempt && maxAttempts) {
        blueText = "Connection Lost"
        blackText = `Reconnecting... (Attempt ${reconnectAttempt} of ${maxAttempts})`
    }

    return (
        <div>
            <PresentationStatusPage blueText={blueText} blackText={blackText}/>
        </div>
    )
}

const PayAttentionPage = () => {
    const icon = <img src={dashiconsMegaphoneIcon} alt="megaphone icon" />
    return (
        <div>
            <PresentationStatusPage icon={icon} blueText="Please Pay Attention" blackText="Your teacher is teaching the lesson, please look at the smart board."/>
        </div>
    )
}

const DoneEarlyPage = () => {
    const icon = <img src={dashiconsMegaphoneIcon} alt="megaphone icon" />
    return (
        <div>
            <PresentationStatusPage icon={icon} blueText="Please Wait..." blackText="You’re finished! But others are still working."/>
        </div>
    )
}

const TeacherInterruptionPage = () => {
    const icon = <img src={dashiconsMegaphoneIcon} alt="megaphone icon" />
    return (
        <div>
            <PresentationStatusPage icon={icon} blueText="Sorry for the interruption" blackText="Your teacher would like to resume the lesson."/>
        </div>
    )
}

const CorrectAnswerPage = () => {
    const icon = <img src={dashiconsYesIcon} alt="yes icon" />
    return (
        <div>
            <PresentationStatusPage icon={icon} blueText="Correct!" blackText="Way to go!"/>
        </div>
    )
}

const IncorrectAnswerPage = () => {
    const icon = <img src={dashiconsPlusIcon} alt="plus icon" className={styles.incorrectIcon} />
    return (
        <div>
            <PresentationStatusPage icon={icon} blueText="Incorrect!" blackText="Good try! Let's keep going."/>
        </div>
    )
}

const QuestionInProgressPage = ({ learningStage }: { learningStage: string }) => {
    return (
        <div className={styles.presentationStatusPage}>
            <div className={styles.iconContainer}>
                <span className={styles.inProgressBlackText}>{`${learningStage} Questions`}</span>
            </div>
            <span className={styles.inProgressBlueText}>in progress...</span>
            {/* Timer only for Check for Understanding; otherwise show Stopwatch */}
            {learningStage === SECTIONS.CHECK_FOR_UNDERSTANDING ? (
                <Timer seconds={300} />
            ) : (
                <Stopwatch />
            )}
        </div>
    )
}

export { PresentationStatusPage, PayAttentionPage, DoneEarlyPage, TeacherInterruptionPage, CorrectAnswerPage, IncorrectAnswerPage, QuestionInProgressPage, ConnectingPage }